import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../utility-types';

import {isMeCoachForEntity} from '../isMeCoachForEntity';

/**
 * In some places, we need to show a course duration as well as its label
 * This util helps us to detect should the duration being showed
 */
export const shouldShowCourseDuration = (
  course?: Nullable<Partial<CourseApiModel>>,
) => Boolean(course?.label) && isMeCoachForEntity(course);
